import { useSelectUser } from '@containers/Store';

export function useUserPaymentMethod() {
  const user = useSelectUser();
  return user.paymentMethod;
}

export default useUserPaymentMethod;